import { useLang } from '@/i18n';
import styles from './index.module.scss';
import EcoFaqTc from 'eco-design/sections/eco-faq-tc';
import EcoTextTc from 'eco-design/sections/eco-text-tc';

export default function Comp() {
    const { t } = useLang('dp3.page_v2.TC');
    const items = [
        {
            title: t('title1'),
            isHeader: true,
        },
        {
            title: t('title2'),
        },
        {
            title: t('title3'),
        },
        {
            title: t('title4'),
        },
        {
            title: t('title5'),
        },
        {
            title: t('title6'),
        },
        {
            title: t('title7'),
        },
        {
            title: t('title8'),
        },
        {
            title: t('title9'),
        },
        {
            title: t('title10'),
        },
        {
            title: t('title11'),
        },
        {
            title: t('tip'),
        },
    ];
    const installationTerms = [
        {
            title: 'EcoFlow Smart Home Panel 2 (or Smart Home Panel 2 bundle) + Installation fee Installation Terms & Conditions',
            isHead: true,
        },
        {
            title: '1. Installation Conditions',
            isOpen: true,
            desc: `
                a. Home circuits that have been modified by customers without permission from the government will not meet the installation conditions.<br/>
                b. If a customer's house is too large, resulting in excessive wiring and undervoltage, there may be a risk that the NEC regulations will not be met, and the installation will be prevented.<br/>
                c. In the event of unforeseen circumstances that may prevent installation, EcoFlow reserves the right to determine the final feasibility of installation.<br/>
                d. Description of the Installation Service Package<br/>
                &nbsp;&nbsp;&nbsp;&nbsp;i. Installation Service Package includes wiring the EcoFlow Smart Home Panel 2 to the existing load center. It does not include wiring the EcoFlow Power Station to solar panels or PV systems. If the customer requires the installation to include wiring to solar panels or PV systems, the electrician reserves the right to refuse to take the order. The installation service excludes:<br/>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;1. Additional material and labor costs due to excessive distance or incompatibility between the existing circuit breaker and Smart Home Panel 2.<br/>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;2. Permit application fees are incurred under applicable laws and regulations in certain areas.<br/>
                &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;3. The electrician's on-site assessment fee can be waived if the circumstance has been assessed by the electrician to be suitable for installation and the customer does not request a refund of the installation service fee.<br/>
                &nbsp;&nbsp;&nbsp;&nbsp;The above extra costs and fees shall be subject to the actual quote from the electrician. Customers are responsible for directly paying the electrician for any extra costs incurred. EcoFlow reserves the right to final interpretation of the installation service fee.<br/>
                &nbsp;&nbsp;&nbsp;&nbsp;ii. By agreeing to EcoFlow's installation services, you consent to the collection and processing of personal information necessary for completing the service. This may include but is not limited to, your name, address, contact information, and any relevant details related to the installation. We will handle your personal information in compliance with applicable data protection laws and regulations and will only use it for the purpose of fulfilling the installation service. Please refrain from directly providing your personal information to the electrician during the installation process, otherwise you will be responsible for any loss or damage caused by the disclosure of such information.`,
        },
        {
            title: '2. Risk Statement of the Installation Service Package',
            isOpen: true,
            desc: `
                a. The option for the installation service package is based on the purchase of Smart Home Panel 2.<br/>
                b. If, after purchasing Smart Home Panel 2, it is concluded through the electrician's assessment that the customer's home situation does not allow for installation of Smart Home Panel 2 and a return of Smart Home Panel 2 is necessary, the cost incurred for the electrician's on-site assessment will be borne by the customer.<br/>
                c. Should a customer opt for our installation service and then decide to return the Smart Home Panel 2 due to dissatisfaction after installation, the paid installation fee cannot be refunded. Additionally, the customer will be responsible for any costs associated with the removal of Smart Home Panel 2.<br/>
                d. The installation service does not include any cleaning or removal of debris generated during the installation process. Residents are responsible for managing and disposing of all trash and debris resulting from the installation.<br/>
                e. Any holes or modifications made to the premises during the installation are considered normal and necessary for the proper completion of the service. The installer shall not be held liable for any unavoidable damages or alterations made to the premises during the installation process.<br/>
                f. Any additional costs arising from the need for extra materials or labor due to a complex installation environment shall be the responsibility of the resident. These costs must be settled by the resident when completing the installation.<br/>
                g. Any product issues or defects resulting from installation by an unauthorized installer shall be the sole responsibility of the resident. The resident shall bear full responsibility for any after-sales service or repairs needed due to such unauthorized installations.`,
        },
    ];

    return (
        <div className={styles.comp} id="TC">
            <div className="ts-container">
                <EcoFaqTc items={items} className="faq-tc" />
                <EcoTextTc items={installationTerms} className="installation-tc" theme="white" />
            </div>
        </div>
    );
}
